import Gravity from 'Gravity';

const mainElements = document.querySelectorAll('.gg-vertical-carousel');

/* eslint-disable */
const verticalCarousel = (module) => {
  const swiper = module.querySelector('.wp-block-statik-slider > .swiper');
  const swiperCover = module.querySelector('.wp-block-cover');

  const initSwiper = ({ swiper: swiperVar }) => {
    swiperVar.params.watchSlidesProgress = true;
    swiperVar.params.observer = true;
    swiperVar.params.observeParents = true;
    swiperVar.params.resizeObserver = false;
    swiperVar.params.mousewheel.enabled = true;
    swiperVar.params.keyboard = {
      enabled: true,
      onlyInViewport: true,
    };
    swiperVar.params.breakpoints = {
      0: {
        direction: 'horizontal',
        spaceBetween: 40,
        slidesPerView: 1,
      },
      1025: {
        direction: 'vertical',
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 40,
      },
    };

    swiperVar.emit('init');
    swiperVar.update();
  };

  const setCoverHeight = () => {
    const coverMinHeight = swiperCover.style.minHeight;

    if (coverMinHeight.length === 0) {
      return;
    }

    swiperCover.style.height = coverMinHeight;
  };

  setCoverHeight();
  initSwiper(swiper);
};

Gravity.ready(() => {
  mainElements.forEach((module) => {
    verticalCarousel(module);
  });
});
